export const AutomationLoopBlue = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.4229 3.57713C17.7742 4.92847 15.9941 8.89956 12.4468 12.4468C8.89956 15.9941 4.92847 17.7742 3.57713 16.4229C2.2258 15.0715 4.00594 11.1004 7.55319 7.55319C11.1004 4.00594 15.0715 2.2258 16.4229 3.57713Z"
      stroke="#225AEA"
      strokeWidth="1.5"
    />
    <path
      d="M16.4229 16.4229C15.0715 17.7742 11.1004 15.9941 7.55319 12.4468C4.00594 8.89955 2.2258 4.92847 3.57713 3.57713C4.92847 2.2258 8.89955 4.00594 12.4468 7.55319C15.9941 11.1004 17.7742 15.0715 16.4229 16.4229Z"
      stroke="#225AEA"
      strokeWidth="1.5"
    />
  </svg>
)

export default AutomationLoopBlue
